import { Button } from 'theme-ui';

const SliderButton = ({ children, onClick, forwardSx = {}, ...props }) => {
  // Slick slider is setting a class on the components.
  delete props.className;
  return (
    <Button
      variant="bare"
      onClick={onClick}
      sx={{
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1,
        ...forwardSx,
      }}
      {...props}
    >
      <div sx={{ display: 'flex', alignItems: 'center' }}>{children}</div>
    </Button>
  );
};

export default SliderButton;
